import React, { useMemo } from "react";

import { ArticleType } from "@/@types/BlogArticle";
import FeaturedGrid from "./featured-grid";
import FeaturedList from "./featured-list";
import { Card, Col, Container, Row } from "reactstrap";
import { otherBlogs } from "@/utils/content";

type FeaturedBlogsProps = {
  featuredArticles: ArticleType[];
  classes: any;
};

const FeaturedBlogs = ({ featuredArticles, classes }: FeaturedBlogsProps) => {
  const content = otherBlogs.en;
  return (
    <section className="my-5">
      <Container>
        <Row>
          <Col className="mb-3" xs={12} md={6}>
            <Card className={classes.cardWrapper}>
              <Row className="m-1">
                {featuredArticles.map((article, i) => (
                  <Col key={article.id} xs={12} md={i === 0 ? 12 : 6}>
                    <FeaturedGrid classes={classes} article={article} />
                  </Col>
                ))}
              </Row>
            </Card>
          </Col>
          <Col xs={12} md={6}>
            <h2 className="fw-bold">{content.mostRecentTitle}</h2>
            {featuredArticles.map((article) => (
              <FeaturedList key={article.id} article={article} />
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FeaturedBlogs;
